module.exports = __webpack_public_path__ + "img/geod_14.e15d40f3.jpg";